module.exports = __webpack_public_path__ + "static/media/block_icon_video.cb75e869.svg";